import PasswordPolicyRestService from '../rest/PasswordPolicyRestService'
import { TFunction } from 'i18next'

class PasswordPolicyService {
  static get() {
    return PasswordPolicyRestService.get()
  }

  static async update(passwordPolicy: any, t: TFunction, setPasswordPolicy: React.Dispatch<any>) {
    try {
      var config = Object.assign({}, passwordPolicy)
      config.blacklist = passwordPolicy.blacklist?.split(',').map((blacklist: string) => blacklist.trim())
      const updatedPolicy = await PasswordPolicyRestService.update(config)
      setPasswordPolicy(updatedPolicy)
      return t('passwordPolicy.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async reset(t: TFunction, setPasswordPolicy: React.Dispatch<any>) {
    try {
      const updatedPolicy = await PasswordPolicyRestService.reset()
      setPasswordPolicy(updatedPolicy)
      return t('passwordPolicy.resetSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default PasswordPolicyService
